/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";

import type { PostLoginBody } from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const postLogin = (
  postLoginBody: BodyType<PostLoginBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/auth/token`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postLoginBody,
      signal,
    },
    options,
  );
};

export const getPostLoginMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postLogin>>,
    TError,
    { data: BodyType<PostLoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postLogin>>,
  TError,
  { data: BodyType<PostLoginBody> },
  TContext
> => {
  const mutationKey = ["postLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postLogin>>,
    { data: BodyType<PostLoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof postLogin>>
>;
export type PostLoginMutationBody = BodyType<PostLoginBody>;
export type PostLoginMutationError = ErrorType<unknown>;

export const usePostLogin = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postLogin>>,
      TError,
      { data: BodyType<PostLoginBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postLogin>>,
  TError,
  { data: BodyType<PostLoginBody> },
  TContext
> => {
  const mutationOptions = getPostLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
